import React, { useMemo } from 'react';
import NavLinkAdapter from '@fuse/core/NavLinkAdapter';
import FuseUtils from '@fuse/utils';
import ListSubheader from '@material-ui/core/ListSubheader';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import * as Actions from 'app/store/actions';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { UserService } from 'app/services/userService';
import userRoles from 'app/userRoles';
import { withRouter } from 'utils/withRouter';
import FuseNavItem from '../FuseNavItem';

const useStyles = makeStyles(theme => ({
  listContainer: props => ({
    '&#dashboard-menu': {
      paddingBottom: '45px'
    },
    '&#access-to-menu': {
      padding: '45px 0',
      backgroundColor: '#fafafa',
      borderTop: '1px solid #e0e0e0'
    },
    '&#termsconditions': {
      borderTop: '1px solid #e0e0e0',
      padding: '45px 0'
    }
  }),
  item: props => ({
    height: 40,
    width: 'calc(100% - 16px)',
    borderRadius: '0 20px 20px 0',
    paddingRight: 12,
    paddingLeft: props.itemPadding > 80 ? 80 : props.itemPadding,
    '& .list-subheader-text': {
      fontWeight: 500,
      fontFamily: 'sofia-pro, sans-serif',
      fontStyle: 'normal',
      fontSize: props.franchise === 'franchise' ? 18 : '1.2rem',
      color: theme.palette.secondary.main
    }
  })
}));

function FuseNavVerticalGroup(props) {
  const user = useSelector(({ auth }) => auth.user);
  const dispatch = useDispatch();

  const theme = useTheme();
  const mdDown = useMediaQuery(theme.breakpoints.down('md'));
  const { item, nestedLevel } = props;

  const classes = useStyles({
    itemPadding: nestedLevel > 0 ? 40 + nestedLevel * 16 : 24,
    franchise: item.display
  });
  const { t } = useTranslation('navigation');

  const hasPermission = useMemo(
    () => FuseUtils.hasPermission(item.auth, user.role),
    [item.auth, user]
  );

  const hasOptionalPermission = useMemo(
    () =>
      FuseUtils.hasOptionalItemPermission(
        item.group,
        item.allowedHairdresserTypes,
        user
      ),
    [item.group, item.allowedHairdresserTypes, user]
  );

  // if(!UserService.hasSomeRoles(user, [userRoles.ROLE_SUPER_ADMIN])) {
  if (
    !hasPermission ||
    !hasOptionalPermission ||
    (item.display !== null && item.display !== user.myGroup?.display_type) ||
    (item.allowedCountries &&
      !user.countries.some(
        country => item.allowedCountries.indexOf(country) >= 0
      ))
  ) {
    return null;
  }
  // }

  return (
    <div className={classes.listContainer} id={item.id}>
      <ListSubheader
        disableSticky
        className={clsx(
          classes.item,
          'list-subheader flex items-center',
          !item.url && 'cursor-default'
        )}
        onClick={ev => mdDown && dispatch(Actions.navbarCloseMobile())}
        component={item.url ? NavLinkAdapter : 'li'}
        to={item.url}
        role="button"
      >
        <span className="list-subheader-text uppercase text-12">
          {item.translate ? t(item.translate) : item.title}
        </span>
      </ListSubheader>

      {item.children && (
        <>
          {item.children.map((_item, index) => (
            <React.Fragment key={`Nav-item-${_item.id}-${index}`}>
              {!user.brands.includes(1) &&
              !user.brands.includes(34) &&
              !user.brands.includes(2) &&
              !user.brands.includes(7) &&
              !user.brands.includes(4) &&
              !user.brands.includes(6) &&
              _item.id === 'dashboard-pub-component' ? null : (
                <FuseNavItem
                  type={`vertical-${_item.type}`}
                  item={_item}
                  nestedLevel={nestedLevel}
                />
              )}
            </React.Fragment>
          ))}
        </>
      )}
    </div>
  );
}

FuseNavVerticalGroup.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    children: PropTypes.array
  })
};

FuseNavVerticalGroup.defaultProps = {};

const NavVerticalGroup = withRouter(React.memo(FuseNavVerticalGroup));

export default NavVerticalGroup;
